export default __webpack_public_path__ + "static/media/wohnungen_intro_web-sm@1x.fcf31f23.webp";